import React, { useState, useEffect } from "react";
import {
    Grid, Card, Paper, Typography, Autocomplete, Box, Button, TextField, FormControl, Divider,
    IconButton, Tooltip,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    useMediaQuery,
    Skeleton,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store/store";
import CustomHeader from "../pageHeader/Index";
import { getTenantDropDownList } from "../../store/thunk/tenantThunk";
import AddApiKey, { maskApiKey } from "./AddApiKey";
import __ from "underscore";
import DeleteIntegration from './DeleteIntegration';
import { Add, Edit, ArrowForwardIos, LinkOff, InsertLink } from "@mui/icons-material";
import AddDeviceDialog from "./AddDevice";
import ConfigureDialog from "./ConfigureDevice";
import { HandleSelectionReturnType } from "../common/LocationSelector";
import { useLocation } from "react-router-dom";
import { DeleteDeviceConfigurationThunk, fetchDeviceProviderConfigurationList, getThirdPartyDevices } from "../../store/thunk/thirdPartyDeviceThunk";
import { getLocationLists } from "../../store/thunk/locationThunk";
import { setTenantId } from "../../store/thunk/commonThunk";
import MUIDataTable from "mui-datatables";

const DeviceIntegrationComponent = () => {
    const dispatch = useAppDispatch();
    const location: any = useLocation();
    const [providerList, setProviderList] = useState<any>([]);
    const [selectedProvider, setSelectedProvider] = useState<any>(null);
    const [editProvider, setEditProvider] = useState<any>(null);
    const [selectedDevice, setSelectedDevice] = useState<any>(null);
    const [tenant, setTenant] = useState<any>(null);
    const [addApiKeyDialog, setAddApiKeyDialog] = useState<any>(false);
    const [addDeviceDialog, setAddDeviceDialog] = useState<any>(false);
    const [openConfigureDialog, setOpenConfigureDialog] = useState<any>(false);
    const { userData } = useAppSelector((state: any) => state.authReducer);
    const [deviceList, setDeviceList] = useState<any[]>([]);
    const [initialValue, setinitialValue] = useState<HandleSelectionReturnType>();
    const [deleteIntegration, setDeleteIntegration] = useState<{ pk: string; sk: string } | null>(null);
    const items = JSON.parse(localStorage.getItem("tenantId") || "{}");
    const { locationList } = useAppSelector((state) => state.locationSlice);
    const { tenantDropDownList } = useAppSelector((state) => state.tenantSlice);
    const { thirdPartyDeviceProviderList, thirdPartyDevices, providerLoader } = useAppSelector((state) => state.thirdPartyDeviceSlice);
    const locationStateData: any = location?.state?.notificationData;
    const defaultProps = {
        options: tenantDropDownList?.getTenants
            ? tenantDropDownList?.getTenants.tenants
            : [],
        getOptionLabel: (option: any) => option.tenant_name,
    };

    useEffect(() => {
        dispatch(getTenantDropDownList({}));
    }, []);

    useEffect(() => {
        if (Array.isArray(thirdPartyDeviceProviderList) && thirdPartyDeviceProviderList.length > 0) {
            setProviderList(thirdPartyDeviceProviderList);
            setSelectedProvider(thirdPartyDeviceProviderList[0]);
        } else {
            setProviderList([]);
            setSelectedProvider(null); // or a default value if needed
        }
    }, [thirdPartyDeviceProviderList]);


    useEffect(() => {
        if (tenant?.tenantCode) {
            dispatch(fetchDeviceProviderConfigurationList({ tenantCode: tenant?.tenantCode }));
        }
    }, [tenant]);

    useEffect(() => {
        let obj: any = {
            name: userData?.name,
            tenantCode: userData?.tenantCode,
            tenantId: userData?.tenantId,
        };
        if (userData.tenantCode) {
            dispatch(fetchDeviceProviderConfigurationList({ tenantCode: userData?.tenantCode }))
            setTenant(obj);
        }
    }, [userData])

    useEffect(() => {
        if (items && items.tenantId) {
            setTenant(items);
        }
    }, []);

    useEffect(() => {
        if (tenant && tenant.tenantId) {
            let request = {
                tenantId: tenant?.tenantCode
            };
            dispatch(getLocationLists(request));
        }
    }, [JSON.stringify(tenant)]);


    const handleClose = () => {
        setDeleteIntegration(null);
    }

    useEffect(() => {
        const fetchThirdPartyDevices = async () => {
            if (selectedProvider?.sk) {
                await dispatch(getThirdPartyDevices({ providerId: selectedProvider.sk }));
            }
        };
        fetchThirdPartyDevices();
    }, [selectedProvider, dispatch]);

    useEffect(() => {
        if (thirdPartyDevices) {
            setDeviceList(thirdPartyDevices);
        }
    }, [thirdPartyDevices]);

    const handleConfigerDevice = (device: any) => {
        setSelectedDevice(device);
        setOpenConfigureDialog(true);
    }

    const handleEditProviderDetails = (provider: any) => {
        setAddApiKeyDialog(true);
        setEditProvider(provider)
    };

    const handleUnLinkDeviceConfiguration = async (device: any) => {
        await dispatch(DeleteDeviceConfigurationThunk({ pk: device?.pk, sk: device?.sk }));
        await dispatch(getThirdPartyDevices({ providerId: selectedProvider?.sk }));
    }

    const getFacility = () => {
        const notificationRoom = [...locationList.getLocations]?.find(
            (item: any) => item?.key === locationStateData?.locationKey
        );
        const notificationFloor = [...locationList.getLocations]?.find(
            (item: any) => item?.key === notificationRoom?.parentKey
        );
        const notificationFacility = [...locationList.getLocations]?.find(
            (item: any) => item?.key === notificationFloor?.parentKey
        );

        return {
            facility: notificationFacility?.key,
            floor: notificationFloor?.key,
            room: notificationRoom?.key,
        };
    };
    useEffect(() => {
        if (locationStateData && locationList?.getLocations?.length > 0)
            setinitialValue(() => {
                return getFacility();
            })
    }, [JSON.stringify(locationList?.getLocations), JSON.stringify(locationStateData)]);

    const getApiKey = (providerData: any) => {
        if (!providerData) return "";
        try {
            const parsedData = JSON.parse(providerData);
            // If there's an API key, mask it for display and return it
            if (parsedData.api_key) {
                return maskApiKey(parsedData.api_key);
            }
        } catch (error) {
            console.error("Error parsing provider data:", error);
        }
        return "";
    };

    const handleChange = (event: any, value: any) => {
        dispatch(setTenantId(value));
        setTenant(value);
    };

    const columns: any = [
        {
            name: "deviceId",
            label: "DEVICE ID",
            options: { filter: true, sort: true }
        },
        {
            name: "deviceName",
            label: "NAME",
            options: { filter: true, sort: true }
        },
        {
            name: "location",
            label: "LOCATION",
            options: { filter: true, sort: true }
        },
        {
            name: "actions",
            // label: "Actions",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value: any, tableMeta: any) => {
                    const device = deviceList[tableMeta.rowIndex];
                    return device.configured ? (
                        <Tooltip title={<Typography>Delete Device Configuration</Typography>} placement="bottom">
                            <IconButton sx={{ padding: 0 }} aria-label="Unlink" onClick={() => handleUnLinkDeviceConfiguration(device)}>
                                <LinkOff color="error" />
                            </IconButton>
                        </Tooltip>
                    ) : (
                        <Tooltip title={<Typography>Device Configuration to Location</Typography>} placement="bottom">
                            <IconButton sx={{ padding: 0 }} aria-label="Link" onClick={() => handleConfigerDevice(device)}>
                                <InsertLink color="primary" />
                            </IconButton>
                        </Tooltip>
                    );
                }
            }
        }
    ];

    const options: any = {
        rowsPerPageOptions: [5, 10, 25],
        sort: true,
        filter: true,
        print: false,
        download: false,
        viewColumns: true,
        responsive: "scroll",
        selectableRows: false,
        setCellProps: () => ({
            style: {
                padding: "0px 4px" // Adjust these values to decrease/increase spacing
            }
        })
    };

    const isMobile = useMediaQuery("(max-width: 600px)");

    return (
        <div>
            <CustomHeader title="Provider Integration" >
                <FormControl margin="normal" sx={{ width: "240px", mr: 1 }}>
                    <Autocomplete
                        {...defaultProps}
                        id="demo-simple-select"
                        onChange={handleChange}
                        disableClearable
                        value={tenant}
                        renderInput={(params) => (
                            <TextField {...params} label="Select Tenant" className="custom-input" />
                        )}
                    />
                </FormControl>
            </CustomHeader>
            <Card
                sx={{
                    px: 1,
                    py: 2,
                    boxShadow: 3,
                    my: 1,
                    mx: 3
                }}
            >
                <Grid container spacing={2} px={1}>
                    <Grid item xs={12}>
                        <Paper sx={{ width: "100%" }}>
                            {/* Header */}
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                <Typography variant="h6" fontWeight="bold">
                                    Provider List
                                </Typography>
                                <Button
                                    startIcon={<Add />}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        setAddApiKeyDialog(true);
                                    }}
                                >
                                    Add New API Key
                                </Button>
                            </Box>
                            <Divider sx={{ px: 2, pb: 0.7 }} />

                            {/* Content: Provider List & Device List */}
                            <Box display="flex" flexDirection={isMobile ? "column" : "row"} sx={{ gap: 2, py: 1 }}>
                                {/* Left Section: Provider List */}
                                <Box
                                    sx={{
                                        width: isMobile ? "100%" : "40%",
                                        bgcolor: "#f5f5f5",
                                        p: 1,
                                        borderRadius: 1,
                                    }}
                                >
                                    <Typography variant="subtitle1" paddingLeft={1} fontSize={14} fontWeight="bold">
                                        Providers
                                    </Typography>
                                    <List>
                                        {/* Header Row */}
                                        <ListItem sx={{ fontWeight: "bold", bgcolor: "#f5f5f5", borderRadius: "8px", mt: 0 }}>
                                            <ListItemText primary={<Typography fontWeight="bold" fontSize={14}>Name</Typography>} sx={{ flex: 1 }} />
                                            <ListItemText primary={<Typography fontWeight="bold" fontSize={14}>Provider</Typography>} sx={{ flex: 1 }} />
                                            <ListItemText primary={<Typography fontWeight="bold" fontSize={14}>API Key</Typography>} sx={{ flex: 1 }} />
                                            <ListItemIcon />
                                        </ListItem>
                                        <Divider sx={{ px: 2, mb: 1 }} />
                                        {/* Provider List */}
                                        <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
                                            {providerLoader ? (
                                                // Show 5 skeleton rows as placeholders
                                                Array.from({ length: 5 }).map((_, index) => (
                                                    <ListItem key={index} sx={{ mb: 1, pr: 0.5, pl: 1 }}>
                                                        <ListItemText
                                                            primary={<Skeleton variant="text" width="80%" height={20} />}
                                                            sx={{ flex: 1 }}
                                                        />
                                                        <ListItemText
                                                            primary={<Skeleton variant="text" width="60%" height={20} />}
                                                            sx={{ flex: 1 }}
                                                        />
                                                        <ListItemText
                                                            primary={<Skeleton variant="text" width="40%" height={20} />}
                                                            sx={{ flex: 1 }}
                                                        />
                                                        <ListItemIcon>
                                                            <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
                                                            <Skeleton variant="circular" width={24} height={24} />
                                                        </ListItemIcon>
                                                    </ListItem>
                                                ))
                                            ) : providerList.length > 0 ? (
                                                providerList.map((provider: any, index: any) => (
                                                    <ListItem
                                                        key={index}
                                                        sx={{
                                                            cursor: "pointer",
                                                            bgcolor: selectedProvider === provider ? "#ddd" : "transparent",
                                                            borderRadius: 1,
                                                            mb: 1,
                                                            pr: 0.5,
                                                            pl: 1,
                                                            transition: "background-color 0.3s",
                                                            "&:hover": { bgcolor: "#e0e0e0" },
                                                        }}
                                                        onClick={() => setSelectedProvider(provider)}
                                                    >
                                                        <ListItemText primary={provider?.name} sx={{ flex: 1 }} />
                                                        <ListItemText primary={provider?.provider} sx={{ flex: 1 }} />
                                                        <ListItemText primary={getApiKey(provider?.data)} sx={{ flex: 1 }} />
                                                        <ListItemIcon>
                                                            <IconButton
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleEditProviderDetails(provider);
                                                                }}
                                                                color="primary"
                                                            >
                                                                <Edit fontSize="small" />
                                                            </IconButton>
                                                            <IconButton color="primary">
                                                                <ArrowForwardIos fontSize="small" />
                                                            </IconButton>
                                                        </ListItemIcon>
                                                    </ListItem>
                                                ))
                                            ) : (
                                                <Typography fontSize={14} textAlign="center" padding={1}>
                                                    No Provider Found.
                                                </Typography>
                                            )}
                                        </Box>

                                    </List>
                                </Box>

                                {/* Right Section: Device List */}
                                <Box
                                    sx={{
                                        width: isMobile ? "100%" : "60%",
                                        bgcolor: "#fff",
                                        p: 1,
                                        borderRadius: 1,
                                        boxShadow: 1,
                                    }}
                                >
                                    {selectedProvider ? (
                                        <>
                                            {/* Header for Device List */}
                                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                                <Typography variant="h6" fontWeight="bold" fontSize={isMobile ? "16px" : "18px"}>
                                                    {selectedProvider?.name} - Devices
                                                </Typography>
                                                <Button startIcon={<Add />} variant="contained" color="primary" onClick={() => { setAddDeviceDialog(true) }}>
                                                    Add New Device
                                                </Button>
                                            </Box>
                                            <Divider sx={{ mb: 0 }} />
                                            <MUIDataTable title="" data={deviceList} columns={columns} options={options} />
                                        </>
                                    ) : (
                                        <Typography fontSize={14} padding={1} textAlign="center">
                                            Select a provider to view devices.
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                            <DeleteIntegration
                                open={!!deleteIntegration}
                                handleClose={handleClose}
                                deleteIntegration={deleteIntegration}
                            />
                        </Paper>
                    </Grid>
                    <AddApiKey providerData={editProvider} tenant={tenant} open={addApiKeyDialog} handleClose={() => { setAddApiKeyDialog(false); setEditProvider(null) }} />
                    <AddDeviceDialog open={addDeviceDialog} selectedProvider={selectedProvider} handleClose={() => { setAddDeviceDialog(false) }} />
                    <ConfigureDialog open={openConfigureDialog} initialValue={initialValue} configuredDevice={selectedDevice} selectedProvider={selectedProvider} tenant={tenant} handleClose={() => { setOpenConfigureDialog(false) }} />

                </Grid>
            </Card>
        </div>
    );
};

export default DeviceIntegrationComponent;
